import React from "react";
import Banner from "../../../../components/Banner";
import AccountSettings from "../../../../components/AccountSettings";
import Header from "../../../../components/Header";
import { PAYMENTS } from "../../../../constants/settingsStrings.js";
import { ArrowLeftIcon } from "@radix-ui/react-icons";
import Topbar from "../../../../components/Topbar";
import Bottombar from "../../../../components/Bottombar";
import { Link } from "react-router-dom";

function Mtn() {
  const text = "";
  return (
    <div className="dark:bg-white h-screen overflow-hidden  dark:text-black dark:h-screen">
      <div className="sm:hidden ">
       
        <Topbar />
      </div>
      <div className="hidden md:block">
        <Header />
      </div>
      <div className="sm:hidden flex space-x-[100px]  mt-7 ">
        <Link to="/settings/paymentmethod">
          <ArrowLeftIcon color="#545454" className="ml-4 w-[17px] h-[17px]" />
        </Link>

        <h3 className="dark:text-black ml">Payment Method</h3>
      </div>

      <div className="mt-5 sm:hidden ">
        <div class="flex justify-between ">
          <div class="w-1/3 text-center">
            <div class="bg-[#42BA96] rounded-full h-[12px] w-[12px] inline-flex items-center justify-center">
              <span class="text-sm font-bold text-white">✓</span>
            </div>
            <div class="mt-2 font-medium text-sm text-gray-500 dark:text-black">
              Details
            </div>
          </div>
          <div class="w-1/3 text-center">
            <div class="bg-[#42BA96] rounded-full h-[12px] w-[12px] inline-flex items-center justify-center pt-1">
              <span class="text-sm font-bold text-white">{}</span>
            </div>
            <div class="mt-2 font-medium text-sm text-gray-500 dark:text-black">
              Payment
            </div>
          </div>
          <div class="w-1/3 text-center">
            <div class="bg-[#42BA96] rounded-full h-[12px] w-[12px] inline-flex items-center justify-center pt-1">
              <span class="text-sm font-bold text-white">{text}</span>
            </div>
            <div class="mt-2 font-medium text-sm text-gray-500 dark:text-black">
              Confirm
            </div>
            {/* <div className="absolute border-2 w-[119px] border-[#EEEEEE] top-[125px] left-[70px] mn-2"></div>
            <div className="absolute border-2 w-[117px] border-[#EEEEEE] top-[125px] left-[202px] mn-2"></div> */}
          </div>
        </div>
      </div>
      <div className="flex items-center justify-center sm:hidden  my-4">
  <div className="h-[115px] w-[346px] flex items-center justify-center rounded-[25px] ">
    <div className="border-2 flex justify-center items-center h-full w-full rounded-[25px] mt-3 bg-banner2 relative sm:hidden">
      <div className="absolute flex space-x-10">
        <h3 className="text-white font-extrabold text-[20px] font-sans ml-5 mt-5">
          GO{" "}
          <span className="border bg-[#0049F5] w-[63px] h-[18px] px-2 text-[14px] text-white rounded-[16px]">
            PRO
          </span>{" "}
          <br />
          PREMIUM!
        </h3>
      </div>
      <div className="ml-[280px] mt-3">
        <img
          src="https://uibfs.s3.eu-north-1.amazonaws.com/Saly-41.png"
          className="w-[87px] h-[98px]"
          alt=""
        />
      </div>
    </div>
  </div>
</div>

      <div className="flex">
        <div className="hidden md:block">
          <AccountSettings active={PAYMENTS} />
        </div>

        <div className="w-[925px]  sm:w-[64vw] mt-2 h-[500px] rounded-[25px] sm:shadow-xl  sm:mx-10 my-4">
          <div className=" hidden md:block ">
            {" "}
            <Banner />
          </div>
          <div className="hidden md:block mt-3">
            <div className="grid place-content-center ">
              <div className=" flex ">
                <div class=" flex space-x-10 ">
                  <div class="w-1/3 text-center mr-3">
                    <div class="bg-[#42BA96] rounded-full h-[25px] w-[25px] inline-flex items-center justify-center">
                      <span class="text-sm font-bold text-white w-[3px] h-[3px] mb-4 mr-3">
                        ✓
                      </span>
                    </div>
                    <div class="mt-2 font-medium text-sm text-gray-500 dark:text-black">
                      Details
                    </div>{" "}
                  </div>
                  <div class="w-1/3 text-center">
                    <div class="bg-[#42BA96] rounded-full h-[25px] w-[25px] inline-flex items-center justify-center pt-6">
                      <span class="text-sm font-bold text-white w-[3px] h-[3px] mb-4 mr-3"></span>
                    </div>
                    <div class="mt-2 font-medium text-sm text-gray-500 dark:text-black">
                      Payment
                    </div>
                  </div>
                  <div class="w-1/3 text-center ml-3">
                    <div class="bg-[#42BA96] rounded-full h-[25px] w-[25px] inline-flex items-center justify-center pt-6">
                      <span class="text-sm font-bold text-white w-[3px] h-[3px] mb-4 mr-3"></span>
                    </div>
                    <div class="mt-2 font-medium text-sm text-gray-500 dark:text-black">
                      Confirm
                    </div>
                    {/* <div className="absolute border-2 w-[78px] border-[#EEEEEE] top-[358px] left-[735px] mn-2"></div>

                    <div className="absolute border-2 w-[70px] border-[#EEEEEE] top-[358px] left-[836px] mn-2"></div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <img
            src={require("../../../../assets/img/mtnlogo.png")}
            alt=""
            className=" h-[48px]  w-[70px]  ml-10 sm:hidden  "
          />
           <div className="ml-7  sm:ml-0">
           <div className="sm:flex justify-between sm:mt-[10px] sm:mr-[80px]   sm:m-0">
            <div className="  ">
              <div className="font-semibold m-4 sm:text-[10px] text-[#202124] dark:text-black font-sans flex sm:space-x-[100px]  space-x-[160px]  text-[14px] ">
                <div>
                  
                  <p>Monthly </p>
                  <p>Taxes</p>
                </div>
                <div className="ml-[70px]">
                  <p>300,000 UGX</p>
                  <p>10,000 UGX</p>
                </div>
              </div>
              <div className="border-[1px] sm:w-[180px] w-[300px] mb-2 ml-4"></div>
              <div className=" font-semibold sm:text-[10px] flex mb-4  sm:mb-0 ml-4 sm:space-x-[100px] space-x-[160px] dark:text-black text-[14px]">
                <p>Subtotal</p>
                <p>310,000 UGXl</p>
              </div>
              <div className="border-[1px] sm:w-[180px] w-[300px] sm:mb-2 mb-6 ml-4"></div>
            </div>
            <div className="sm:space-y-2 space-y-5 mb-2">
              <div className="border-[2px] border-[#BDBDBD] w-[328px] h-[40px]  grid place-content-center sm:h[30px] rounded-[4px] ">
                <input
                  type="text"
                  placeholder="Mobile Number "
                  className="text-[#212529] tex-[10px] outline-none dark:text-black dark:bg-white w-[310px] placeholder:px-2 placeholder:font-bold placeholder:text-black"
                />
              </div>
              <div className="border-[2px] border-[#BDBDBD] w-[328px] h-[40px] sm:h[30px] grid place-content-center rounded-[4px] ">
                <input
                  type="text"
                  placeholder="Amount"
                  className="text-[#212529] tex-[10px] outline-none dark:text-black dark:bg-white w-[310px]  placeholder:px-2 placeholder:font-bold placeholder:text-black "
                />
              </div>
            </div>
          </div>
           </div>
          <div className="flex py-3 mt-3   ">
          <div className="border md:block hidden rounded-[15.875px] w-[70px] h-[48px] items-center  justify-center lg:flex border-[#D9D9D9] sm:ml-10 relative bottom-[0px]">
              <img
                src={require("../../../../assets/img/mtnlogo.png")}
                alt=""
                className=" h-[48px]  w-[70px]   md:block hidden "
              />
            </div>

           <div>
             <Link to="/settings/paymentmethod/mobilemoney/mtn/pin">
            <button className="m-7  bg-[#0049F5] text-white w-[315px] sm:h-[34.68px] h-[54.68px] rounded-[27.34px] sm:mt-3 sm:m-0 sm:ml-[250px]">
                Continue
              </button>
            </Link>
           </div>
          </div>
        </div>
      </div>
      <h3 className="dark:text-black absolute text-[12px] hidden md:block  text-[#878787] font-[900] mt-9  sm:left-[50%]  bottom-[70px] left-[40%]">
          Terms and conditions{" "}
      </h3>
      <Bottombar activeBar={'settings'}/>
    </div>
  );
}

export default Mtn;
